/* eslint-disable no-unused-vars */
import service from "@/utils/request";
import { getStorage } from "@/utils/storage";

function main(query, variables = null) {
  return service({
    url: "/fleet/graphql",
    method: "post",
    data: JSON.stringify({ query: query, variables: variables }),
    headers: {
      "Content-Type": "text/plain",
    },
  });
}
function getTokenAuto() {
  let token = getStorage();
  return getStorage('x-portal-token') === 'yes' ?
    `token: null, adminToken: "${token}"`:
    `token: "${token}", adminToken: null`
}

function getContactInfoDetail(id) {
  return main(`{
    queryContactInfoDetail(${getTokenAuto()},id: ${id}){ 
        contact {
          id
          city
          companyName
          notes
          attribute
          street
          state
          country
          commodity
          mainContactPerson
          contactNumber
          email
          zipCode
          locationName
          facilityId
          lat
          lon
          zipCode
          timeZone
          showAddress
          address
        }
        contactPersonList {
          id
          ContactId
          role
          contactNumber
          firstName
          lastName
          email
          mainContactPerson
      }
    } 
  }`);
}

function addContactPersonInfo(data) {
  return main(`{ 
      addContactPersonInfo(${getTokenAuto()}, contactId: ${
    data.contactId
  }, contactPerson: {
        firstName: ${(data.firstName && '"' + data.firstName + '"') || null}
        lastName: ${(data.lastName && '"' + data.lastName + '"') || null}
        contactNumber: ${(data.contactNumber &&
          '"' + data.contactNumber + '"') ||
          null}
        email: ${(data.email && '"' + data.email + '"') || null}
        mainContactPerson: ${data.mainContactPerson}
        role: ${(data.role && '"' + data.role + '"') || null}
      }){
        code
        message
     }
  }`);
}
function editContactPersonDetail(data) {
  return main(`{ 
    editContactPersonDetail(${getTokenAuto()}, id: ${
    data.contactId
  }, contactPerson: {
        firstName: ${(data.firstName && '"' + data.firstName + '"') || null}
        lastName: ${(data.lastName && '"' + data.lastName + '"') || null}
        contactNumber: ${(data.contactNumber &&
          '"' + data.contactNumber + '"') ||
          null}
        email: ${(data.email && '"' + data.email + '"') || null}
        mainContactPerson: ${data.mainContactPerson}
        role: ${(data.role && '"' + data.role + '"') || null}
      }){
        code
        message
     }
  }`);
}
function queryContactInfoList(
  page,
  size,
  type,
  companyName,
  mainContactPerson,
  citySite
) {
  page = page || 0;
  size = size || 15;
  type = type || "all";
  companyName =
    companyName && companyName.length ? JSON.stringify(companyName) : null;
  mainContactPerson =
    mainContactPerson && mainContactPerson.length
      ? JSON.stringify(mainContactPerson)
      : null;
  size = size === -1 ? null : size;
  citySite = citySite && citySite.length ? JSON.stringify(citySite) : null;

  return main(`{ 
     queryContactInfoList(${getTokenAuto()}, page: ${page}, size: ${size}, type: "${type}", companyName: ${companyName}, mainContactPerson: ${mainContactPerson}, citySite: ${citySite}) {
        total 
        is_blank
        contactList {
            id
            city
            companyName
            notes
            attribute
            street
            state
            country
            lat
            lon
            commodity
            mainContactPerson
            contactNumber
            email
            locationName
            zipCode
            timeZone
            showAddress
            address
        }
     }
  }`);
}
function formatContactPerson(item) {
  return `{
        firstName: "${item.firstName}"
        lastName: "${item.lastName}"
        contactNumber: "${item.contactNumber}"
        email: "${item.email}"
        mainContactPerson: ${item.mainContactPerson}
        role: "${item.role}"
    }`;
}
function addContactInfo(data) {
  console.log("111", data);
  return main(`{ 
    addContactInfo(${getTokenAuto()}, contact: {
      city: ${(data.city && '"' + data.city + '"') || null}
      companyName: ${(data.companyName && '"' + data.companyName + '"') || null}
      notes: ${(data.notes && '"' + data.notes + '"') || null}
      street: ${(data.street && '"' + data.street + '"') || null}
      state: ${(data.state && '"' + data.state + '"') || null}
      country: ${(data.country && '"' + data.country + '"') || null}
      zipCode: ${(data.zipCode && '"' + data.zipCode + '"') || null}
      attribute:${(data.attribute && '"' + data.attribute + '"') || null}
      commodity: ${(data.commodity && '"' + data.commodity.join(",") + '"') ||
        null}
      locationName:${(data.locationName && '"' + data.locationName + '"') ||
        null}
      address:${(data.address && '"' + data.address + '"') || null}
      timeZone:${(data.timeZone && '"' + data.timeZone + '"') || null}
      lat:${data.lat || null}
      lon:${data.lon || null}
      showAddress:${(data.showAddress && '"' + data.showAddress + '"') || null}
      facilityId:${data.facilityId || -1}
      contactPerson:  [
        ${data.contactPerson.map(formatContactPerson).join(",\n")}
      ]
  }) {
        code
        message
        data 
     }
  }`);
}
function editContactInfoDetail(data) {
  return main(`{ 
    editContactInfoDetail(${getTokenAuto()},id: ${
    data.contactId
  } contact: {
      city: ${(data.city && '"' + data.city + '"') || '"' + null + '"'}
      companyName: ${(data.companyName && '"' + data.companyName + '"') || '"' + null + '"'}
      notes: ${(data.notes && '"' + data.notes + '"') || '"' + null + '"'}
      street: ${(data.street && '"' + data.street + '"') || '"' + null + '"'}
      state: ${(data.regisProvince && '"' + data.regisProvince + '"') || '"' + null + '"'}
      country: ${(data.regisState && '"' + data.regisState + '"') || '"' + null + '"'}
      zipCode: ${(data.zipCode && '"' + data.zipCode + '"') || '"' + null + '"'}
      attribute:${(data.attribute && '"' + data.attribute + '"') || '"' + null + '"'}
      commodity: ${data.commodity && '"' + data.commodity.join(",") + '"'}
      locationName:${(data.locationName && '"' + data.locationName + '"') ||
      '"' + null + '"'}
      address:${(data.address && '"' + data.address + '"') || '"' + null + '"'}
      timeZone:${(data.timeZone && '"' + data.timeZone + '"') || '"' + null + '"'}
      lat:${data.lat || null }
      lon:${data.lon || null }
      facilityId:${data.facilityId || -1}
      showAddress:${(data.showAddress && '"' + data.showAddress + '"') || '"' + null + '"'}
  }) {
        code
        message
     }
  }`);
}
function queryFilterEnums(data) {
  return main(`{ 
    queryFilterEnums(${getTokenAuto()},type:"${data.type}") {
      companyName
      cityState
      mainContactPerson
     }
  }`);
}
function deleteContactInfo(id) {
  return main(`{ 
    deleteContactInfo(${getTokenAuto()},id: [${id}]) {
      code
      message
   }
  }`);
}
function deleteContactPersonInfo(id) {
  return main(`{ 
    deleteContactPersonInfo(${getTokenAuto()},id: [${id}]) {
      code
      message
   }
  }`);
}
export default {
  getContactInfoDetail,
  queryContactInfoList,
  addContactInfo,
  addContactPersonInfo,
  queryFilterEnums,
  deleteContactInfo,
  deleteContactPersonInfo,
  editContactPersonDetail,
  editContactInfoDetail,
};
